import type { LeagueSummary } from "@softmax/observatory-client/types";
import { curatedLeagues } from "../coworlds";
import { slugifyLeagueName, watchableLeagues } from "../leagues";
import { featuredCoworlds } from "./site-shape";

function recommendationRank(league: LeagueSummary): number {
  const index = featuredCoworlds.indexOf(
    slugifyLeagueName(league.game.coworld_name ?? league.game.name),
  );

  return index === -1 ? featuredCoworlds.length : index;
}

export function recommendedGames(leagues: LeagueSummary[]): {
  featured: LeagueSummary | null;
  cards: LeagueSummary[];
} {
  const visible = curatedLeagues(watchableLeagues(leagues));
  const featured =
    visible.find((league) => league.is_game_of_week) ?? visible[0];

  if (!featured) return { featured: null, cards: [] };

  const cards = visible
    .filter((league) => league.game.id !== featured.game.id)
    .toSorted(
      (left, right) =>
        recommendationRank(left) - recommendationRank(right) ||
        left.game.name.localeCompare(right.game.name),
    )
    .slice(0, 3);

  return { featured, cards };
}
